export const SET_INGREDIENTS = 'SET_INGREDIENTS';
export const SELECT_INGREDIENT = 'SELECT_INGREDIENT';
export const RELEASE_INGREDIENT = 'RELEASE_INGREDIENT';
